import { createIcon } from './createIcon'

export const NewsIcon = createIcon({
  displayName: 'NewsIcon',
  viewBox: '0 0 16 16',
  path: [
    <g clipPath="url(#clip0_713_7198)">
      <path
        d="M14.6667 0H1.33333C0.979711 0 0.640573 0.140476 0.390524 0.390524C0.140476 0.640573 0 0.979711 0 1.33333L0 14.6667C0 15.0203 0.140476 15.3594 0.390524 15.6095C0.640573 15.8595 0.979711 16 1.33333 16H14.6667C15.0203 16 15.3594 15.8595 15.6095 15.6095C15.8595 15.3594 16 15.0203 16 14.6667V1.33333C16 0.979711 15.8595 0.640573 15.6095 0.390524C15.3594 0.140476 15.0203 0 14.6667 0V0ZM14.6667 14.3333C14.6667 14.4217 14.6315 14.5065 14.569 14.569C14.5065 14.6315 14.4217 14.6667 14.3333 14.6667H1.66667C1.57826 14.6667 1.49348 14.6315 1.43096 14.569C1.36845 14.5065 1.33333 14.4217 1.33333 14.3333V1.66667C1.33333 1.57826 1.36845 1.49348 1.43096 1.43096C1.49348 1.36845 1.57826 1.33333 1.66667 1.33333H14.3333C14.3771 1.3328 14.4204 1.34142 14.4606 1.35864C14.5008 1.37587 14.5369 1.40131 14.5667 1.43333C14.5987 1.4631 14.6241 1.49923 14.6414 1.53942C14.6586 1.5796 14.6672 1.62295 14.6667 1.66667V14.3333Z"
        fill="currentColor"
      />
      <path
        d="M12.3333 2.66667H3.66665C3.20641 2.66667 2.83331 3.03977 2.83331 3.50001V5.16667C2.83331 5.62691 3.20641 6 3.66665 6H12.3333C12.7935 6 13.1666 5.62691 13.1666 5.16667V3.50001C13.1666 3.03977 12.7935 2.66667 12.3333 2.66667Z"
        fill="currentColor"
      />
      <path
        d="M6.99998 7.33333H3.33331C3.05717 7.33333 2.83331 7.55719 2.83331 7.83333V8.16666C2.83331 8.4428 3.05717 8.66666 3.33331 8.66666H6.99998C7.27612 8.66666 7.49998 8.4428 7.49998 8.16666V7.83333C7.49998 7.55719 7.27612 7.33333 6.99998 7.33333Z"
        fill="currentColor"
      />
      <path
        d="M6.99998 9.66667H3.33331C3.05717 9.66667 2.83331 9.89053 2.83331 10.1667V10.5C2.83331 10.7761 3.05717 11 3.33331 11H6.99998C7.27612 11 7.49998 10.7761 7.49998 10.5V10.1667C7.49998 9.89053 7.27612 9.66667 6.99998 9.66667Z"
        fill="currentColor"
      />
      <path
        d="M6.99998 12H3.33331C3.05717 12 2.83331 12.2239 2.83331 12.5V12.8333C2.83331 13.1095 3.05717 13.3333 3.33331 13.3333H6.99998C7.27612 13.3333 7.49998 13.1095 7.49998 12.8333V12.5C7.49998 12.2239 7.27612 12 6.99998 12Z"
        fill="currentColor"
      />
      <path
        d="M12.6667 12H9C8.72386 12 8.5 12.2239 8.5 12.5V12.8333C8.5 13.1095 8.72386 13.3333 9 13.3333H12.6667C12.9428 13.3333 13.1667 13.1095 13.1667 12.8333V12.5C13.1667 12.2239 12.9428 12 12.6667 12Z"
        fill="currentColor"
      />
      <path
        d="M12.6667 7.33333H9C8.72386 7.33333 8.5 7.55719 8.5 7.83333V8.16666C8.5 8.4428 8.72386 8.66666 9 8.66666H12.6667C12.9428 8.66666 13.1667 8.4428 13.1667 8.16666V7.83333C13.1667 7.55719 12.9428 7.33333 12.6667 7.33333Z"
        fill="currentColor"
      />
      <path
        d="M12.6667 9.66667H9C8.72386 9.66667 8.5 9.89053 8.5 10.1667V10.5C8.5 10.7761 8.72386 11 9 11H12.6667C12.9428 11 13.1667 10.7761 13.1667 10.5V10.1667C13.1667 9.89053 12.9428 9.66667 12.6667 9.66667Z"
        fill="currentColor"
      />
    </g>,
    <defs>
      <clipPath id="clip0_713_7198">
        <rect width="16" height="16" fill="currentColor" />
      </clipPath>
    </defs>,
  ],
})
